import { DtoId } from '@/shared/lib/sj-orm/models/base.dto';

export enum ConflictResult {
  REPLACE = 'replace',
  COPY = 'copy',
  SKIP = 'skip',
}

export type DocumentsConflictResolutionMap = Map<DtoId, ConflictResult>;
